// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/image.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { SoftwareMode, softwareModeFromJSON, softwareModeToJSON } from "../models/fabric";
import {
  FabricImageUpdate,
  FabricSoftwareConfig,
  ImagePackageInfo,
  NodeImageUpdate,
  SwitchGroupImageUpdate,
  SwitchGroupSoftwareConfig,
} from "../models/image";
import { DeviceImages } from "../software_update/update_common";

export const protobufPackage = "configd";

export enum FabricImageUpdateStage {
  FABRIC_IMAGE_STAGE_UNSPECIFIED = 0,
  CONFIGURED = 1,
  STAGED = 2,
  RUNNING = 3,
  CANDIDATE = 4,
  EXPIRED = 5,
  UNRECOGNIZED = -1,
}

export function fabricImageUpdateStageFromJSON(object: any): FabricImageUpdateStage {
  switch (object) {
    case 0:
    case "FABRIC_IMAGE_STAGE_UNSPECIFIED":
      return FabricImageUpdateStage.FABRIC_IMAGE_STAGE_UNSPECIFIED;
    case 1:
    case "CONFIGURED":
      return FabricImageUpdateStage.CONFIGURED;
    case 2:
    case "STAGED":
      return FabricImageUpdateStage.STAGED;
    case 3:
    case "RUNNING":
      return FabricImageUpdateStage.RUNNING;
    case 4:
    case "CANDIDATE":
      return FabricImageUpdateStage.CANDIDATE;
    case 5:
    case "EXPIRED":
      return FabricImageUpdateStage.EXPIRED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricImageUpdateStage.UNRECOGNIZED;
  }
}

export function fabricImageUpdateStageToJSON(object: FabricImageUpdateStage): string {
  switch (object) {
    case FabricImageUpdateStage.FABRIC_IMAGE_STAGE_UNSPECIFIED:
      return "FABRIC_IMAGE_STAGE_UNSPECIFIED";
    case FabricImageUpdateStage.CONFIGURED:
      return "CONFIGURED";
    case FabricImageUpdateStage.STAGED:
      return "STAGED";
    case FabricImageUpdateStage.RUNNING:
      return "RUNNING";
    case FabricImageUpdateStage.CANDIDATE:
      return "CANDIDATE";
    case FabricImageUpdateStage.EXPIRED:
      return "EXPIRED";
    case FabricImageUpdateStage.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Get the committed image update configuration from a fabric */
export interface GetCommittedFabricImageUpdatesRequest {
  /** The org uuid */
  orgId: string;
  /** The fabric uuid */
  fabricId: string[];
  /** The lookback window in days */
  lookbackDays: number;
  /** The fabricId or name of the fabric intended for the image update */
  targetFabricId: string;
}

/** GetCommittedFabricImageUpdatesResponse encapsulates the committed fabric image update objects. */
export interface GetCommittedFabricImageUpdatesResponse {
  targetImages: FabricImageUpdate[];
  runningImages: FabricImageUpdate[];
  /** The platforms used by bound nodes from the the target fabric */
  boundPlatforms: string[];
  /** The model names configured on the enabled nodes from the target fabric. */
  modelNames: string[];
  /** The committed switch group software configurations */
  switchGroupSwConfs: SwitchGroupSoftwareConfig[];
}

export interface ImagePackagesResponse {
  /** The list of added packages */
  addedPackages: ImagePackageInfo[];
  /** The list of updated packages */
  updatedPackages: ImagePackageInfo[];
}

export interface GetImagePackagesResponse {
  packages: ImagePackageInfo[];
}

/** AddImagePackagesServiceRequest requests to add a set of device image packages to the global.image_package table */
export interface AddImagePackagesServiceRequest {
  deviceImages: DeviceImages | undefined;
}

/** GetImagePackagesServiceRequest retrieves the image packages that match the given parameters */
export interface GetImagePackagesServiceRequest {
  /** The release tag */
  tag: string;
  /** The arch type amd64(default) or arm64 */
  arch: string;
  /** The image package name */
  name: string;
  /** The image release type */
  releaseType: string;
  /** The image platform */
  platform: string;
  /** The search lookback time in days */
  lookbackDays: number;
}

/** DeleteImagePackagesRequestInternal requests to remove the image packages associated with a tag */
export interface DeleteImagePackagesServiceRequest {
  /** The package release tag */
  tag: string;
}

/** AddFabricSoftwareConfigRequest sets a FabricSoftwareConfig configuration object in a fabric */
export interface AddFabricSoftwareConfigRequest {
  /** The fabric id or name */
  fabricId: string;
  swConf: FabricSoftwareConfig | undefined;
}

/** UpdateFabricSoftwareModeRequest sets turn on/off the maintenance mode */
export interface UpdateFabricSoftwareModeRequest {
  /** The fabric id or name */
  fabricId: string;
  /** Software mode */
  softwareMode: SoftwareMode;
  /** flag to skip checking the device reboot status */
  skipDeviceReadinessCheck: boolean;
}

/** UpdateFabricSoftwareRunningImageRequest updates the fabric's running image configuration */
export interface UpdateFabricSoftwareRunningImageRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The fabric's running version */
  runningImage:
    | FabricImageUpdate
    | undefined;
  /** Software mode */
  softwareMode: SoftwareMode;
  /** flag to skip checking the device reboot status */
  skipDeviceReadinessCheck: boolean;
}

/** UpdateFabricSoftwareTargetImageRequest updates the fabric's target image configuration */
export interface UpdateFabricSoftwareTargetImageRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The fabric's running version */
  targetImage: FabricImageUpdate | undefined;
}

/** UpdateFabricSoftwareNodeImagesRequest updates the node image configurations */
export interface UpdateFabricSoftwareNodeImagesRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The list of node images */
  nodeImages: NodeImageUpdate[];
}

/** GetFabricSoftwareConfigRequest gets the FabricSoftwareConfig from the running config or the default candidate. */
export interface GetFabricSoftwareConfigRequest {
  /** The list of fabric ids or names. */
  fabricId: string;
  /** The candidate configuration name. If not set, the default candidate configuration values are returned. */
  candidate: string;
}

/** DeleteFabricSoftwareConfigRequest deletes the FabricSoftwareConfig from the default candidate */
export interface DeleteFabricSoftwareConfigRequest {
  /** The fabric id or name */
  fabricId: string;
}

/** DeleteFabricRunningImageRequest deletes the running image configuration from the FabricSoftwareConfig */
export interface DeleteFabricRunningImageRequest {
  /** The fabric id or name */
  fabricId: string;
}

/** DeleteFabricTargetImageRequest deletes the target image configuration from the FabricSoftwareConfig */
export interface DeleteFabricTargetImageRequest {
  /** The fabric id or name */
  fabricId: string;
}

/** DeleteFabricSoftwareNodeImagesRequest deletes all node image configurations from the FabricSoftwareConfig */
export interface DeleteFabricNodeImagesRequest {
  /** The fabric id or name */
  fabricId: string;
}

/** AddSwitchGroupSoftwareConfigRequest sets a SwitchGroupSoftwareConfig configuration object */
export interface AddSwitchGroupSoftwareConfigRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The switch group id or name */
  switchGroupId: string;
  switchGroupSwConf: SwitchGroupSoftwareConfig | undefined;
}

/** UpdateSwitchGroupSoftwareTargetImageRequest updates the switch group's target image configuration */
export interface UpdateSwitchGroupSoftwareTargetImageRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The switch group id or name */
  switchGroupId: string;
  /** The switch group's target version */
  targetImage: SwitchGroupImageUpdate | undefined;
}

/** GetSwitchGroupSoftwareConfigRequest gets the SwitchGroupSoftwareConfig from the running config or the default candidate. */
export interface GetSwitchGroupSoftwareConfigRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The switch group id or name. */
  switchGroupId: string;
  /** The candidate configuration name. */
  candidate: string;
}

/** DeleteSwitchGroupSoftwareConfigRequest deletes the SwitchGroupSoftwareConfig from the default candidate */
export interface DeleteSwitchGroupSoftwareConfigRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The switch group id or name */
  switchGroupId: string;
}

/** DeleteSwitchGroupTargetImageRequest deletes the target image configuration from the SwitchGroupSoftwareConfig */
export interface DeleteSwitchGroupTargetImageRequest {
  /** The fabric id or name */
  fabricId: string;
  /** The switch group id or name */
  switchGroupId: string;
}

/** SetOrgLabelsRequest updates the org labels for testing purposes */
export interface SetOrgLabelsRequest {
  /** org uuid */
  orgId: string;
  /** list of labels */
  labels: string[];
}

/** GetOrgLabelsRequest requests the labels assigned to the org */
export interface GetOrgLabelsRequest {
  /** org uuid */
  orgId: string;
}

/** GetOrgLabelsResponse returns the list of labels assigned to the org */
export interface OrgLabelsResponse {
  /** org uuid */
  orgId: string;
  /** list of labels */
  labels: string[];
}

/** FirmwareNodePorts represents a node with a list of ports */
export interface FirmwareNodePorts {
  nodeName: string;
  /** port names, e.g., Ethernet1_1 */
  portNames: string[];
}

/** OpticsFirmwareFilter represents a filter with AND rules for optics firmware update */
export interface OpticsFirmwareFilter {
  /** The pluggable pid */
  opticsPid: string;
  /** part number */
  opticsModel: string;
  /** the switch group ids or names */
  switchGroups: string[];
  nodePorts: FirmwareNodePorts[];
}

/** UpgradeOpticsFirmwareRequest requests to upgrade the optics firmware to the latest version */
export interface UpgradeOpticsFirmwareRequest {
  /** The fabric id or name */
  fabricId: string;
  /** A list of filters that specifies OR rules across the filters */
  filters: OpticsFirmwareFilter[];
  /** flag to activate the upgrade, if not set, only download the latest firmware */
  active: boolean;
}

/** OpticsFirmwareConfig represents a node with a list of optical ports */
export interface OpticsFirmwareConfig {
  nodeName: string;
  /** port names, e.g., Ethernet1_1 */
  portName: string;
  opticsPid: string;
  opticsModel: string;
  /** the target firmware version */
  targetVersion: string;
  /** flag to activate the upgrade, if not set, only download the latest firmware */
  activated: boolean;
}

/** UpgradeOpticsFirmwareResponse returns the list of optics firmware configs */
export interface UpgradeOpticsFirmwareResponse {
  opticsFirmwareConfig: OpticsFirmwareConfig[];
}

/**
 * GetOpticsFirmwareUpdateInfoRequest requests to get the optics firmware update info.
 * All non-empty fields are ANDed; repeated values within a field are ORed.
 */
export interface GetOpticsFirmwareUpdateInfoRequest {
  /** The fabric id or name */
  fabricId: string;
  /** OR across optics PIDs */
  opticsPids: string[];
  /** OR across optics models (part numbers) */
  opticsModels: string[];
  /** OR across switch group ids or names */
  switchGroups: string[];
  /** OR across entries; format: "node_name" (all ports) or "node_name/port_name" */
  nodePorts: string[];
}

export interface OpticsFirmwareUpdateInfo {
  nodeName: string;
  /** port names, e.g., Ethernet1_1 */
  portName: string;
  opticsPid: string;
  opticsModel: string;
  /** the target firmware version */
  targetVersion: string;
  /** flag that indicates the target version has been activated */
  activated: boolean;
  /** current running version on device */
  activeFirmware: string;
  /** current standby version on device */
  inactiveFirmware: string;
}

export interface GetOpticsFirmwareUpdateInfoResponse {
  opticsFirmwareInfo: OpticsFirmwareUpdateInfo[];
}

function createBaseGetCommittedFabricImageUpdatesRequest(): GetCommittedFabricImageUpdatesRequest {
  return { orgId: "", fabricId: [], lookbackDays: 0, targetFabricId: "" };
}

export const GetCommittedFabricImageUpdatesRequest: MessageFns<GetCommittedFabricImageUpdatesRequest> = {
  encode(message: GetCommittedFabricImageUpdatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    for (const v of message.fabricId) {
      writer.uint32(18).string(v!);
    }
    if (message.lookbackDays !== 0) {
      writer.uint32(24).uint32(message.lookbackDays);
    }
    if (message.targetFabricId !== "") {
      writer.uint32(34).string(message.targetFabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCommittedFabricImageUpdatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCommittedFabricImageUpdatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.lookbackDays = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.targetFabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCommittedFabricImageUpdatesRequest {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: globalThis.Array.isArray(object?.fabricId) ? object.fabricId.map((e: any) => globalThis.String(e)) : [],
      lookbackDays: isSet(object.lookbackDays) ? globalThis.Number(object.lookbackDays) : 0,
      targetFabricId: isSet(object.targetFabricId) ? globalThis.String(object.targetFabricId) : "",
    };
  },

  toJSON(message: GetCommittedFabricImageUpdatesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId?.length) {
      obj.fabricId = message.fabricId;
    }
    if (message.lookbackDays !== 0) {
      obj.lookbackDays = Math.round(message.lookbackDays);
    }
    if (message.targetFabricId !== "") {
      obj.targetFabricId = message.targetFabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCommittedFabricImageUpdatesRequest>, I>>(
    base?: I,
  ): GetCommittedFabricImageUpdatesRequest {
    return GetCommittedFabricImageUpdatesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCommittedFabricImageUpdatesRequest>, I>>(
    object: I,
  ): GetCommittedFabricImageUpdatesRequest {
    const message = createBaseGetCommittedFabricImageUpdatesRequest();
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId?.map((e) => e) || [];
    message.lookbackDays = object.lookbackDays ?? 0;
    message.targetFabricId = object.targetFabricId ?? "";
    return message;
  },
};

function createBaseGetCommittedFabricImageUpdatesResponse(): GetCommittedFabricImageUpdatesResponse {
  return { targetImages: [], runningImages: [], boundPlatforms: [], modelNames: [], switchGroupSwConfs: [] };
}

export const GetCommittedFabricImageUpdatesResponse: MessageFns<GetCommittedFabricImageUpdatesResponse> = {
  encode(message: GetCommittedFabricImageUpdatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.targetImages) {
      FabricImageUpdate.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.runningImages) {
      FabricImageUpdate.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.boundPlatforms) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.modelNames) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.switchGroupSwConfs) {
      SwitchGroupSoftwareConfig.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCommittedFabricImageUpdatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCommittedFabricImageUpdatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.targetImages.push(FabricImageUpdate.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.runningImages.push(FabricImageUpdate.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.boundPlatforms.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modelNames.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.switchGroupSwConfs.push(SwitchGroupSoftwareConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCommittedFabricImageUpdatesResponse {
    return {
      targetImages: globalThis.Array.isArray(object?.targetImages)
        ? object.targetImages.map((e: any) => FabricImageUpdate.fromJSON(e))
        : [],
      runningImages: globalThis.Array.isArray(object?.runningImages)
        ? object.runningImages.map((e: any) => FabricImageUpdate.fromJSON(e))
        : [],
      boundPlatforms: globalThis.Array.isArray(object?.boundPlatforms)
        ? object.boundPlatforms.map((e: any) => globalThis.String(e))
        : [],
      modelNames: globalThis.Array.isArray(object?.modelNames)
        ? object.modelNames.map((e: any) => globalThis.String(e))
        : [],
      switchGroupSwConfs: globalThis.Array.isArray(object?.switchGroupSwConfs)
        ? object.switchGroupSwConfs.map((e: any) => SwitchGroupSoftwareConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCommittedFabricImageUpdatesResponse): unknown {
    const obj: any = {};
    if (message.targetImages?.length) {
      obj.targetImages = message.targetImages.map((e) => FabricImageUpdate.toJSON(e));
    }
    if (message.runningImages?.length) {
      obj.runningImages = message.runningImages.map((e) => FabricImageUpdate.toJSON(e));
    }
    if (message.boundPlatforms?.length) {
      obj.boundPlatforms = message.boundPlatforms;
    }
    if (message.modelNames?.length) {
      obj.modelNames = message.modelNames;
    }
    if (message.switchGroupSwConfs?.length) {
      obj.switchGroupSwConfs = message.switchGroupSwConfs.map((e) => SwitchGroupSoftwareConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCommittedFabricImageUpdatesResponse>, I>>(
    base?: I,
  ): GetCommittedFabricImageUpdatesResponse {
    return GetCommittedFabricImageUpdatesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCommittedFabricImageUpdatesResponse>, I>>(
    object: I,
  ): GetCommittedFabricImageUpdatesResponse {
    const message = createBaseGetCommittedFabricImageUpdatesResponse();
    message.targetImages = object.targetImages?.map((e) => FabricImageUpdate.fromPartial(e)) || [];
    message.runningImages = object.runningImages?.map((e) => FabricImageUpdate.fromPartial(e)) || [];
    message.boundPlatforms = object.boundPlatforms?.map((e) => e) || [];
    message.modelNames = object.modelNames?.map((e) => e) || [];
    message.switchGroupSwConfs = object.switchGroupSwConfs?.map((e) => SwitchGroupSoftwareConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseImagePackagesResponse(): ImagePackagesResponse {
  return { addedPackages: [], updatedPackages: [] };
}

export const ImagePackagesResponse: MessageFns<ImagePackagesResponse> = {
  encode(message: ImagePackagesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.addedPackages) {
      ImagePackageInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.updatedPackages) {
      ImagePackageInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImagePackagesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImagePackagesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.addedPackages.push(ImagePackageInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedPackages.push(ImagePackageInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImagePackagesResponse {
    return {
      addedPackages: globalThis.Array.isArray(object?.addedPackages)
        ? object.addedPackages.map((e: any) => ImagePackageInfo.fromJSON(e))
        : [],
      updatedPackages: globalThis.Array.isArray(object?.updatedPackages)
        ? object.updatedPackages.map((e: any) => ImagePackageInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ImagePackagesResponse): unknown {
    const obj: any = {};
    if (message.addedPackages?.length) {
      obj.addedPackages = message.addedPackages.map((e) => ImagePackageInfo.toJSON(e));
    }
    if (message.updatedPackages?.length) {
      obj.updatedPackages = message.updatedPackages.map((e) => ImagePackageInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImagePackagesResponse>, I>>(base?: I): ImagePackagesResponse {
    return ImagePackagesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImagePackagesResponse>, I>>(object: I): ImagePackagesResponse {
    const message = createBaseImagePackagesResponse();
    message.addedPackages = object.addedPackages?.map((e) => ImagePackageInfo.fromPartial(e)) || [];
    message.updatedPackages = object.updatedPackages?.map((e) => ImagePackageInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetImagePackagesResponse(): GetImagePackagesResponse {
  return { packages: [] };
}

export const GetImagePackagesResponse: MessageFns<GetImagePackagesResponse> = {
  encode(message: GetImagePackagesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.packages) {
      ImagePackageInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetImagePackagesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetImagePackagesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.packages.push(ImagePackageInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetImagePackagesResponse {
    return {
      packages: globalThis.Array.isArray(object?.packages)
        ? object.packages.map((e: any) => ImagePackageInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetImagePackagesResponse): unknown {
    const obj: any = {};
    if (message.packages?.length) {
      obj.packages = message.packages.map((e) => ImagePackageInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetImagePackagesResponse>, I>>(base?: I): GetImagePackagesResponse {
    return GetImagePackagesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetImagePackagesResponse>, I>>(object: I): GetImagePackagesResponse {
    const message = createBaseGetImagePackagesResponse();
    message.packages = object.packages?.map((e) => ImagePackageInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddImagePackagesServiceRequest(): AddImagePackagesServiceRequest {
  return { deviceImages: undefined };
}

export const AddImagePackagesServiceRequest: MessageFns<AddImagePackagesServiceRequest> = {
  encode(message: AddImagePackagesServiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceImages !== undefined) {
      DeviceImages.encode(message.deviceImages, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddImagePackagesServiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddImagePackagesServiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceImages = DeviceImages.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddImagePackagesServiceRequest {
    return { deviceImages: isSet(object.deviceImages) ? DeviceImages.fromJSON(object.deviceImages) : undefined };
  },

  toJSON(message: AddImagePackagesServiceRequest): unknown {
    const obj: any = {};
    if (message.deviceImages !== undefined) {
      obj.deviceImages = DeviceImages.toJSON(message.deviceImages);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddImagePackagesServiceRequest>, I>>(base?: I): AddImagePackagesServiceRequest {
    return AddImagePackagesServiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddImagePackagesServiceRequest>, I>>(
    object: I,
  ): AddImagePackagesServiceRequest {
    const message = createBaseAddImagePackagesServiceRequest();
    message.deviceImages = (object.deviceImages !== undefined && object.deviceImages !== null)
      ? DeviceImages.fromPartial(object.deviceImages)
      : undefined;
    return message;
  },
};

function createBaseGetImagePackagesServiceRequest(): GetImagePackagesServiceRequest {
  return { tag: "", arch: "", name: "", releaseType: "", platform: "", lookbackDays: 0 };
}

export const GetImagePackagesServiceRequest: MessageFns<GetImagePackagesServiceRequest> = {
  encode(message: GetImagePackagesServiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    if (message.arch !== "") {
      writer.uint32(18).string(message.arch);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.releaseType !== "") {
      writer.uint32(34).string(message.releaseType);
    }
    if (message.platform !== "") {
      writer.uint32(42).string(message.platform);
    }
    if (message.lookbackDays !== 0) {
      writer.uint32(48).uint32(message.lookbackDays);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetImagePackagesServiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetImagePackagesServiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.arch = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.releaseType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.platform = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.lookbackDays = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetImagePackagesServiceRequest {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      arch: isSet(object.arch) ? globalThis.String(object.arch) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      releaseType: isSet(object.releaseType) ? globalThis.String(object.releaseType) : "",
      platform: isSet(object.platform) ? globalThis.String(object.platform) : "",
      lookbackDays: isSet(object.lookbackDays) ? globalThis.Number(object.lookbackDays) : 0,
    };
  },

  toJSON(message: GetImagePackagesServiceRequest): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.arch !== "") {
      obj.arch = message.arch;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.releaseType !== "") {
      obj.releaseType = message.releaseType;
    }
    if (message.platform !== "") {
      obj.platform = message.platform;
    }
    if (message.lookbackDays !== 0) {
      obj.lookbackDays = Math.round(message.lookbackDays);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetImagePackagesServiceRequest>, I>>(base?: I): GetImagePackagesServiceRequest {
    return GetImagePackagesServiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetImagePackagesServiceRequest>, I>>(
    object: I,
  ): GetImagePackagesServiceRequest {
    const message = createBaseGetImagePackagesServiceRequest();
    message.tag = object.tag ?? "";
    message.arch = object.arch ?? "";
    message.name = object.name ?? "";
    message.releaseType = object.releaseType ?? "";
    message.platform = object.platform ?? "";
    message.lookbackDays = object.lookbackDays ?? 0;
    return message;
  },
};

function createBaseDeleteImagePackagesServiceRequest(): DeleteImagePackagesServiceRequest {
  return { tag: "" };
}

export const DeleteImagePackagesServiceRequest: MessageFns<DeleteImagePackagesServiceRequest> = {
  encode(message: DeleteImagePackagesServiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteImagePackagesServiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteImagePackagesServiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteImagePackagesServiceRequest {
    return { tag: isSet(object.tag) ? globalThis.String(object.tag) : "" };
  },

  toJSON(message: DeleteImagePackagesServiceRequest): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteImagePackagesServiceRequest>, I>>(
    base?: I,
  ): DeleteImagePackagesServiceRequest {
    return DeleteImagePackagesServiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteImagePackagesServiceRequest>, I>>(
    object: I,
  ): DeleteImagePackagesServiceRequest {
    const message = createBaseDeleteImagePackagesServiceRequest();
    message.tag = object.tag ?? "";
    return message;
  },
};

function createBaseAddFabricSoftwareConfigRequest(): AddFabricSoftwareConfigRequest {
  return { fabricId: "", swConf: undefined };
}

export const AddFabricSoftwareConfigRequest: MessageFns<AddFabricSoftwareConfigRequest> = {
  encode(message: AddFabricSoftwareConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.swConf !== undefined) {
      FabricSoftwareConfig.encode(message.swConf, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricSoftwareConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricSoftwareConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.swConf = FabricSoftwareConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricSoftwareConfigRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      swConf: isSet(object.swConf) ? FabricSoftwareConfig.fromJSON(object.swConf) : undefined,
    };
  },

  toJSON(message: AddFabricSoftwareConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.swConf !== undefined) {
      obj.swConf = FabricSoftwareConfig.toJSON(message.swConf);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricSoftwareConfigRequest>, I>>(base?: I): AddFabricSoftwareConfigRequest {
    return AddFabricSoftwareConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricSoftwareConfigRequest>, I>>(
    object: I,
  ): AddFabricSoftwareConfigRequest {
    const message = createBaseAddFabricSoftwareConfigRequest();
    message.fabricId = object.fabricId ?? "";
    message.swConf = (object.swConf !== undefined && object.swConf !== null)
      ? FabricSoftwareConfig.fromPartial(object.swConf)
      : undefined;
    return message;
  },
};

function createBaseUpdateFabricSoftwareModeRequest(): UpdateFabricSoftwareModeRequest {
  return { fabricId: "", softwareMode: 0, skipDeviceReadinessCheck: false };
}

export const UpdateFabricSoftwareModeRequest: MessageFns<UpdateFabricSoftwareModeRequest> = {
  encode(message: UpdateFabricSoftwareModeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.softwareMode !== 0) {
      writer.uint32(16).int32(message.softwareMode);
    }
    if (message.skipDeviceReadinessCheck !== false) {
      writer.uint32(24).bool(message.skipDeviceReadinessCheck);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricSoftwareModeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricSoftwareModeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.softwareMode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.skipDeviceReadinessCheck = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricSoftwareModeRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      softwareMode: isSet(object.softwareMode) ? softwareModeFromJSON(object.softwareMode) : 0,
      skipDeviceReadinessCheck: isSet(object.skipDeviceReadinessCheck)
        ? globalThis.Boolean(object.skipDeviceReadinessCheck)
        : false,
    };
  },

  toJSON(message: UpdateFabricSoftwareModeRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.softwareMode !== 0) {
      obj.softwareMode = softwareModeToJSON(message.softwareMode);
    }
    if (message.skipDeviceReadinessCheck !== false) {
      obj.skipDeviceReadinessCheck = message.skipDeviceReadinessCheck;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricSoftwareModeRequest>, I>>(base?: I): UpdateFabricSoftwareModeRequest {
    return UpdateFabricSoftwareModeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricSoftwareModeRequest>, I>>(
    object: I,
  ): UpdateFabricSoftwareModeRequest {
    const message = createBaseUpdateFabricSoftwareModeRequest();
    message.fabricId = object.fabricId ?? "";
    message.softwareMode = object.softwareMode ?? 0;
    message.skipDeviceReadinessCheck = object.skipDeviceReadinessCheck ?? false;
    return message;
  },
};

function createBaseUpdateFabricSoftwareRunningImageRequest(): UpdateFabricSoftwareRunningImageRequest {
  return { fabricId: "", runningImage: undefined, softwareMode: 0, skipDeviceReadinessCheck: false };
}

export const UpdateFabricSoftwareRunningImageRequest: MessageFns<UpdateFabricSoftwareRunningImageRequest> = {
  encode(message: UpdateFabricSoftwareRunningImageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.runningImage !== undefined) {
      FabricImageUpdate.encode(message.runningImage, writer.uint32(18).fork()).join();
    }
    if (message.softwareMode !== 0) {
      writer.uint32(24).int32(message.softwareMode);
    }
    if (message.skipDeviceReadinessCheck !== false) {
      writer.uint32(32).bool(message.skipDeviceReadinessCheck);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricSoftwareRunningImageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricSoftwareRunningImageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.runningImage = FabricImageUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.softwareMode = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.skipDeviceReadinessCheck = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricSoftwareRunningImageRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      runningImage: isSet(object.runningImage) ? FabricImageUpdate.fromJSON(object.runningImage) : undefined,
      softwareMode: isSet(object.softwareMode) ? softwareModeFromJSON(object.softwareMode) : 0,
      skipDeviceReadinessCheck: isSet(object.skipDeviceReadinessCheck)
        ? globalThis.Boolean(object.skipDeviceReadinessCheck)
        : false,
    };
  },

  toJSON(message: UpdateFabricSoftwareRunningImageRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.runningImage !== undefined) {
      obj.runningImage = FabricImageUpdate.toJSON(message.runningImage);
    }
    if (message.softwareMode !== 0) {
      obj.softwareMode = softwareModeToJSON(message.softwareMode);
    }
    if (message.skipDeviceReadinessCheck !== false) {
      obj.skipDeviceReadinessCheck = message.skipDeviceReadinessCheck;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricSoftwareRunningImageRequest>, I>>(
    base?: I,
  ): UpdateFabricSoftwareRunningImageRequest {
    return UpdateFabricSoftwareRunningImageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricSoftwareRunningImageRequest>, I>>(
    object: I,
  ): UpdateFabricSoftwareRunningImageRequest {
    const message = createBaseUpdateFabricSoftwareRunningImageRequest();
    message.fabricId = object.fabricId ?? "";
    message.runningImage = (object.runningImage !== undefined && object.runningImage !== null)
      ? FabricImageUpdate.fromPartial(object.runningImage)
      : undefined;
    message.softwareMode = object.softwareMode ?? 0;
    message.skipDeviceReadinessCheck = object.skipDeviceReadinessCheck ?? false;
    return message;
  },
};

function createBaseUpdateFabricSoftwareTargetImageRequest(): UpdateFabricSoftwareTargetImageRequest {
  return { fabricId: "", targetImage: undefined };
}

export const UpdateFabricSoftwareTargetImageRequest: MessageFns<UpdateFabricSoftwareTargetImageRequest> = {
  encode(message: UpdateFabricSoftwareTargetImageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.targetImage !== undefined) {
      FabricImageUpdate.encode(message.targetImage, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricSoftwareTargetImageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricSoftwareTargetImageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.targetImage = FabricImageUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricSoftwareTargetImageRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      targetImage: isSet(object.targetImage) ? FabricImageUpdate.fromJSON(object.targetImage) : undefined,
    };
  },

  toJSON(message: UpdateFabricSoftwareTargetImageRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.targetImage !== undefined) {
      obj.targetImage = FabricImageUpdate.toJSON(message.targetImage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricSoftwareTargetImageRequest>, I>>(
    base?: I,
  ): UpdateFabricSoftwareTargetImageRequest {
    return UpdateFabricSoftwareTargetImageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricSoftwareTargetImageRequest>, I>>(
    object: I,
  ): UpdateFabricSoftwareTargetImageRequest {
    const message = createBaseUpdateFabricSoftwareTargetImageRequest();
    message.fabricId = object.fabricId ?? "";
    message.targetImage = (object.targetImage !== undefined && object.targetImage !== null)
      ? FabricImageUpdate.fromPartial(object.targetImage)
      : undefined;
    return message;
  },
};

function createBaseUpdateFabricSoftwareNodeImagesRequest(): UpdateFabricSoftwareNodeImagesRequest {
  return { fabricId: "", nodeImages: [] };
}

export const UpdateFabricSoftwareNodeImagesRequest: MessageFns<UpdateFabricSoftwareNodeImagesRequest> = {
  encode(message: UpdateFabricSoftwareNodeImagesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.nodeImages) {
      NodeImageUpdate.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricSoftwareNodeImagesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricSoftwareNodeImagesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeImages.push(NodeImageUpdate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricSoftwareNodeImagesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeImages: globalThis.Array.isArray(object?.nodeImages)
        ? object.nodeImages.map((e: any) => NodeImageUpdate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UpdateFabricSoftwareNodeImagesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeImages?.length) {
      obj.nodeImages = message.nodeImages.map((e) => NodeImageUpdate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricSoftwareNodeImagesRequest>, I>>(
    base?: I,
  ): UpdateFabricSoftwareNodeImagesRequest {
    return UpdateFabricSoftwareNodeImagesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricSoftwareNodeImagesRequest>, I>>(
    object: I,
  ): UpdateFabricSoftwareNodeImagesRequest {
    const message = createBaseUpdateFabricSoftwareNodeImagesRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeImages = object.nodeImages?.map((e) => NodeImageUpdate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetFabricSoftwareConfigRequest(): GetFabricSoftwareConfigRequest {
  return { fabricId: "", candidate: "" };
}

export const GetFabricSoftwareConfigRequest: MessageFns<GetFabricSoftwareConfigRequest> = {
  encode(message: GetFabricSoftwareConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricSoftwareConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricSoftwareConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricSoftwareConfigRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetFabricSoftwareConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricSoftwareConfigRequest>, I>>(base?: I): GetFabricSoftwareConfigRequest {
    return GetFabricSoftwareConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricSoftwareConfigRequest>, I>>(
    object: I,
  ): GetFabricSoftwareConfigRequest {
    const message = createBaseGetFabricSoftwareConfigRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseDeleteFabricSoftwareConfigRequest(): DeleteFabricSoftwareConfigRequest {
  return { fabricId: "" };
}

export const DeleteFabricSoftwareConfigRequest: MessageFns<DeleteFabricSoftwareConfigRequest> = {
  encode(message: DeleteFabricSoftwareConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricSoftwareConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricSoftwareConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricSoftwareConfigRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: DeleteFabricSoftwareConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricSoftwareConfigRequest>, I>>(
    base?: I,
  ): DeleteFabricSoftwareConfigRequest {
    return DeleteFabricSoftwareConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricSoftwareConfigRequest>, I>>(
    object: I,
  ): DeleteFabricSoftwareConfigRequest {
    const message = createBaseDeleteFabricSoftwareConfigRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseDeleteFabricRunningImageRequest(): DeleteFabricRunningImageRequest {
  return { fabricId: "" };
}

export const DeleteFabricRunningImageRequest: MessageFns<DeleteFabricRunningImageRequest> = {
  encode(message: DeleteFabricRunningImageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricRunningImageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricRunningImageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricRunningImageRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: DeleteFabricRunningImageRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricRunningImageRequest>, I>>(base?: I): DeleteFabricRunningImageRequest {
    return DeleteFabricRunningImageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricRunningImageRequest>, I>>(
    object: I,
  ): DeleteFabricRunningImageRequest {
    const message = createBaseDeleteFabricRunningImageRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseDeleteFabricTargetImageRequest(): DeleteFabricTargetImageRequest {
  return { fabricId: "" };
}

export const DeleteFabricTargetImageRequest: MessageFns<DeleteFabricTargetImageRequest> = {
  encode(message: DeleteFabricTargetImageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricTargetImageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricTargetImageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricTargetImageRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: DeleteFabricTargetImageRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricTargetImageRequest>, I>>(base?: I): DeleteFabricTargetImageRequest {
    return DeleteFabricTargetImageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricTargetImageRequest>, I>>(
    object: I,
  ): DeleteFabricTargetImageRequest {
    const message = createBaseDeleteFabricTargetImageRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseDeleteFabricNodeImagesRequest(): DeleteFabricNodeImagesRequest {
  return { fabricId: "" };
}

export const DeleteFabricNodeImagesRequest: MessageFns<DeleteFabricNodeImagesRequest> = {
  encode(message: DeleteFabricNodeImagesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricNodeImagesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricNodeImagesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricNodeImagesRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: DeleteFabricNodeImagesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricNodeImagesRequest>, I>>(base?: I): DeleteFabricNodeImagesRequest {
    return DeleteFabricNodeImagesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricNodeImagesRequest>, I>>(
    object: I,
  ): DeleteFabricNodeImagesRequest {
    const message = createBaseDeleteFabricNodeImagesRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseAddSwitchGroupSoftwareConfigRequest(): AddSwitchGroupSoftwareConfigRequest {
  return { fabricId: "", switchGroupId: "", switchGroupSwConf: undefined };
}

export const AddSwitchGroupSoftwareConfigRequest: MessageFns<AddSwitchGroupSoftwareConfigRequest> = {
  encode(message: AddSwitchGroupSoftwareConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    if (message.switchGroupSwConf !== undefined) {
      SwitchGroupSoftwareConfig.encode(message.switchGroupSwConf, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSwitchGroupSoftwareConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSwitchGroupSoftwareConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.switchGroupSwConf = SwitchGroupSoftwareConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSwitchGroupSoftwareConfigRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      switchGroupSwConf: isSet(object.switchGroupSwConf)
        ? SwitchGroupSoftwareConfig.fromJSON(object.switchGroupSwConf)
        : undefined,
    };
  },

  toJSON(message: AddSwitchGroupSoftwareConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.switchGroupSwConf !== undefined) {
      obj.switchGroupSwConf = SwitchGroupSoftwareConfig.toJSON(message.switchGroupSwConf);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSwitchGroupSoftwareConfigRequest>, I>>(
    base?: I,
  ): AddSwitchGroupSoftwareConfigRequest {
    return AddSwitchGroupSoftwareConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSwitchGroupSoftwareConfigRequest>, I>>(
    object: I,
  ): AddSwitchGroupSoftwareConfigRequest {
    const message = createBaseAddSwitchGroupSoftwareConfigRequest();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    message.switchGroupSwConf = (object.switchGroupSwConf !== undefined && object.switchGroupSwConf !== null)
      ? SwitchGroupSoftwareConfig.fromPartial(object.switchGroupSwConf)
      : undefined;
    return message;
  },
};

function createBaseUpdateSwitchGroupSoftwareTargetImageRequest(): UpdateSwitchGroupSoftwareTargetImageRequest {
  return { fabricId: "", switchGroupId: "", targetImage: undefined };
}

export const UpdateSwitchGroupSoftwareTargetImageRequest: MessageFns<UpdateSwitchGroupSoftwareTargetImageRequest> = {
  encode(
    message: UpdateSwitchGroupSoftwareTargetImageRequest,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    if (message.targetImage !== undefined) {
      SwitchGroupImageUpdate.encode(message.targetImage, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSwitchGroupSoftwareTargetImageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSwitchGroupSoftwareTargetImageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.targetImage = SwitchGroupImageUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSwitchGroupSoftwareTargetImageRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      targetImage: isSet(object.targetImage) ? SwitchGroupImageUpdate.fromJSON(object.targetImage) : undefined,
    };
  },

  toJSON(message: UpdateSwitchGroupSoftwareTargetImageRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.targetImage !== undefined) {
      obj.targetImage = SwitchGroupImageUpdate.toJSON(message.targetImage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSwitchGroupSoftwareTargetImageRequest>, I>>(
    base?: I,
  ): UpdateSwitchGroupSoftwareTargetImageRequest {
    return UpdateSwitchGroupSoftwareTargetImageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSwitchGroupSoftwareTargetImageRequest>, I>>(
    object: I,
  ): UpdateSwitchGroupSoftwareTargetImageRequest {
    const message = createBaseUpdateSwitchGroupSoftwareTargetImageRequest();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    message.targetImage = (object.targetImage !== undefined && object.targetImage !== null)
      ? SwitchGroupImageUpdate.fromPartial(object.targetImage)
      : undefined;
    return message;
  },
};

function createBaseGetSwitchGroupSoftwareConfigRequest(): GetSwitchGroupSoftwareConfigRequest {
  return { fabricId: "", switchGroupId: "", candidate: "" };
}

export const GetSwitchGroupSoftwareConfigRequest: MessageFns<GetSwitchGroupSoftwareConfigRequest> = {
  encode(message: GetSwitchGroupSoftwareConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupSoftwareConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupSoftwareConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupSoftwareConfigRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupSoftwareConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupSoftwareConfigRequest>, I>>(
    base?: I,
  ): GetSwitchGroupSoftwareConfigRequest {
    return GetSwitchGroupSoftwareConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupSoftwareConfigRequest>, I>>(
    object: I,
  ): GetSwitchGroupSoftwareConfigRequest {
    const message = createBaseGetSwitchGroupSoftwareConfigRequest();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseDeleteSwitchGroupSoftwareConfigRequest(): DeleteSwitchGroupSoftwareConfigRequest {
  return { fabricId: "", switchGroupId: "" };
}

export const DeleteSwitchGroupSoftwareConfigRequest: MessageFns<DeleteSwitchGroupSoftwareConfigRequest> = {
  encode(message: DeleteSwitchGroupSoftwareConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSwitchGroupSoftwareConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSwitchGroupSoftwareConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSwitchGroupSoftwareConfigRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
    };
  },

  toJSON(message: DeleteSwitchGroupSoftwareConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteSwitchGroupSoftwareConfigRequest>, I>>(
    base?: I,
  ): DeleteSwitchGroupSoftwareConfigRequest {
    return DeleteSwitchGroupSoftwareConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteSwitchGroupSoftwareConfigRequest>, I>>(
    object: I,
  ): DeleteSwitchGroupSoftwareConfigRequest {
    const message = createBaseDeleteSwitchGroupSoftwareConfigRequest();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    return message;
  },
};

function createBaseDeleteSwitchGroupTargetImageRequest(): DeleteSwitchGroupTargetImageRequest {
  return { fabricId: "", switchGroupId: "" };
}

export const DeleteSwitchGroupTargetImageRequest: MessageFns<DeleteSwitchGroupTargetImageRequest> = {
  encode(message: DeleteSwitchGroupTargetImageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSwitchGroupTargetImageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSwitchGroupTargetImageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSwitchGroupTargetImageRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
    };
  },

  toJSON(message: DeleteSwitchGroupTargetImageRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteSwitchGroupTargetImageRequest>, I>>(
    base?: I,
  ): DeleteSwitchGroupTargetImageRequest {
    return DeleteSwitchGroupTargetImageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteSwitchGroupTargetImageRequest>, I>>(
    object: I,
  ): DeleteSwitchGroupTargetImageRequest {
    const message = createBaseDeleteSwitchGroupTargetImageRequest();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    return message;
  },
};

function createBaseSetOrgLabelsRequest(): SetOrgLabelsRequest {
  return { orgId: "", labels: [] };
}

export const SetOrgLabelsRequest: MessageFns<SetOrgLabelsRequest> = {
  encode(message: SetOrgLabelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    for (const v of message.labels) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetOrgLabelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetOrgLabelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetOrgLabelsRequest {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: SetOrgLabelsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetOrgLabelsRequest>, I>>(base?: I): SetOrgLabelsRequest {
    return SetOrgLabelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetOrgLabelsRequest>, I>>(object: I): SetOrgLabelsRequest {
    const message = createBaseSetOrgLabelsRequest();
    message.orgId = object.orgId ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetOrgLabelsRequest(): GetOrgLabelsRequest {
  return { orgId: "" };
}

export const GetOrgLabelsRequest: MessageFns<GetOrgLabelsRequest> = {
  encode(message: GetOrgLabelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrgLabelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrgLabelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrgLabelsRequest {
    return { orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "" };
  },

  toJSON(message: GetOrgLabelsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrgLabelsRequest>, I>>(base?: I): GetOrgLabelsRequest {
    return GetOrgLabelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrgLabelsRequest>, I>>(object: I): GetOrgLabelsRequest {
    const message = createBaseGetOrgLabelsRequest();
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseOrgLabelsResponse(): OrgLabelsResponse {
  return { orgId: "", labels: [] };
}

export const OrgLabelsResponse: MessageFns<OrgLabelsResponse> = {
  encode(message: OrgLabelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    for (const v of message.labels) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgLabelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgLabelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgLabelsResponse {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: OrgLabelsResponse): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgLabelsResponse>, I>>(base?: I): OrgLabelsResponse {
    return OrgLabelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgLabelsResponse>, I>>(object: I): OrgLabelsResponse {
    const message = createBaseOrgLabelsResponse();
    message.orgId = object.orgId ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    return message;
  },
};

function createBaseFirmwareNodePorts(): FirmwareNodePorts {
  return { nodeName: "", portNames: [] };
}

export const FirmwareNodePorts: MessageFns<FirmwareNodePorts> = {
  encode(message: FirmwareNodePorts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    for (const v of message.portNames) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FirmwareNodePorts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFirmwareNodePorts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FirmwareNodePorts {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      portNames: globalThis.Array.isArray(object?.portNames)
        ? object.portNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FirmwareNodePorts): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.portNames?.length) {
      obj.portNames = message.portNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FirmwareNodePorts>, I>>(base?: I): FirmwareNodePorts {
    return FirmwareNodePorts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FirmwareNodePorts>, I>>(object: I): FirmwareNodePorts {
    const message = createBaseFirmwareNodePorts();
    message.nodeName = object.nodeName ?? "";
    message.portNames = object.portNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseOpticsFirmwareFilter(): OpticsFirmwareFilter {
  return { opticsPid: "", opticsModel: "", switchGroups: [], nodePorts: [] };
}

export const OpticsFirmwareFilter: MessageFns<OpticsFirmwareFilter> = {
  encode(message: OpticsFirmwareFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.opticsPid !== "") {
      writer.uint32(10).string(message.opticsPid);
    }
    if (message.opticsModel !== "") {
      writer.uint32(18).string(message.opticsModel);
    }
    for (const v of message.switchGroups) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.nodePorts) {
      FirmwareNodePorts.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpticsFirmwareFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpticsFirmwareFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.opticsPid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.opticsModel = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.switchGroups.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nodePorts.push(FirmwareNodePorts.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpticsFirmwareFilter {
    return {
      opticsPid: isSet(object.opticsPid) ? globalThis.String(object.opticsPid) : "",
      opticsModel: isSet(object.opticsModel) ? globalThis.String(object.opticsModel) : "",
      switchGroups: globalThis.Array.isArray(object?.switchGroups)
        ? object.switchGroups.map((e: any) => globalThis.String(e))
        : [],
      nodePorts: globalThis.Array.isArray(object?.nodePorts)
        ? object.nodePorts.map((e: any) => FirmwareNodePorts.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OpticsFirmwareFilter): unknown {
    const obj: any = {};
    if (message.opticsPid !== "") {
      obj.opticsPid = message.opticsPid;
    }
    if (message.opticsModel !== "") {
      obj.opticsModel = message.opticsModel;
    }
    if (message.switchGroups?.length) {
      obj.switchGroups = message.switchGroups;
    }
    if (message.nodePorts?.length) {
      obj.nodePorts = message.nodePorts.map((e) => FirmwareNodePorts.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpticsFirmwareFilter>, I>>(base?: I): OpticsFirmwareFilter {
    return OpticsFirmwareFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpticsFirmwareFilter>, I>>(object: I): OpticsFirmwareFilter {
    const message = createBaseOpticsFirmwareFilter();
    message.opticsPid = object.opticsPid ?? "";
    message.opticsModel = object.opticsModel ?? "";
    message.switchGroups = object.switchGroups?.map((e) => e) || [];
    message.nodePorts = object.nodePorts?.map((e) => FirmwareNodePorts.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpgradeOpticsFirmwareRequest(): UpgradeOpticsFirmwareRequest {
  return { fabricId: "", filters: [], active: false };
}

export const UpgradeOpticsFirmwareRequest: MessageFns<UpgradeOpticsFirmwareRequest> = {
  encode(message: UpgradeOpticsFirmwareRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.filters) {
      OpticsFirmwareFilter.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.active !== false) {
      writer.uint32(24).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpgradeOpticsFirmwareRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpgradeOpticsFirmwareRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.filters.push(OpticsFirmwareFilter.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpgradeOpticsFirmwareRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      filters: globalThis.Array.isArray(object?.filters)
        ? object.filters.map((e: any) => OpticsFirmwareFilter.fromJSON(e))
        : [],
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: UpgradeOpticsFirmwareRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => OpticsFirmwareFilter.toJSON(e));
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpgradeOpticsFirmwareRequest>, I>>(base?: I): UpgradeOpticsFirmwareRequest {
    return UpgradeOpticsFirmwareRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpgradeOpticsFirmwareRequest>, I>>(object: I): UpgradeOpticsFirmwareRequest {
    const message = createBaseUpgradeOpticsFirmwareRequest();
    message.fabricId = object.fabricId ?? "";
    message.filters = object.filters?.map((e) => OpticsFirmwareFilter.fromPartial(e)) || [];
    message.active = object.active ?? false;
    return message;
  },
};

function createBaseOpticsFirmwareConfig(): OpticsFirmwareConfig {
  return { nodeName: "", portName: "", opticsPid: "", opticsModel: "", targetVersion: "", activated: false };
}

export const OpticsFirmwareConfig: MessageFns<OpticsFirmwareConfig> = {
  encode(message: OpticsFirmwareConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    if (message.portName !== "") {
      writer.uint32(18).string(message.portName);
    }
    if (message.opticsPid !== "") {
      writer.uint32(26).string(message.opticsPid);
    }
    if (message.opticsModel !== "") {
      writer.uint32(34).string(message.opticsModel);
    }
    if (message.targetVersion !== "") {
      writer.uint32(42).string(message.targetVersion);
    }
    if (message.activated !== false) {
      writer.uint32(48).bool(message.activated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpticsFirmwareConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpticsFirmwareConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.opticsPid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.opticsModel = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.activated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpticsFirmwareConfig {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      opticsPid: isSet(object.opticsPid) ? globalThis.String(object.opticsPid) : "",
      opticsModel: isSet(object.opticsModel) ? globalThis.String(object.opticsModel) : "",
      targetVersion: isSet(object.targetVersion) ? globalThis.String(object.targetVersion) : "",
      activated: isSet(object.activated) ? globalThis.Boolean(object.activated) : false,
    };
  },

  toJSON(message: OpticsFirmwareConfig): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.opticsPid !== "") {
      obj.opticsPid = message.opticsPid;
    }
    if (message.opticsModel !== "") {
      obj.opticsModel = message.opticsModel;
    }
    if (message.targetVersion !== "") {
      obj.targetVersion = message.targetVersion;
    }
    if (message.activated !== false) {
      obj.activated = message.activated;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpticsFirmwareConfig>, I>>(base?: I): OpticsFirmwareConfig {
    return OpticsFirmwareConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpticsFirmwareConfig>, I>>(object: I): OpticsFirmwareConfig {
    const message = createBaseOpticsFirmwareConfig();
    message.nodeName = object.nodeName ?? "";
    message.portName = object.portName ?? "";
    message.opticsPid = object.opticsPid ?? "";
    message.opticsModel = object.opticsModel ?? "";
    message.targetVersion = object.targetVersion ?? "";
    message.activated = object.activated ?? false;
    return message;
  },
};

function createBaseUpgradeOpticsFirmwareResponse(): UpgradeOpticsFirmwareResponse {
  return { opticsFirmwareConfig: [] };
}

export const UpgradeOpticsFirmwareResponse: MessageFns<UpgradeOpticsFirmwareResponse> = {
  encode(message: UpgradeOpticsFirmwareResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.opticsFirmwareConfig) {
      OpticsFirmwareConfig.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpgradeOpticsFirmwareResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpgradeOpticsFirmwareResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.opticsFirmwareConfig.push(OpticsFirmwareConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpgradeOpticsFirmwareResponse {
    return {
      opticsFirmwareConfig: globalThis.Array.isArray(object?.opticsFirmwareConfig)
        ? object.opticsFirmwareConfig.map((e: any) => OpticsFirmwareConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UpgradeOpticsFirmwareResponse): unknown {
    const obj: any = {};
    if (message.opticsFirmwareConfig?.length) {
      obj.opticsFirmwareConfig = message.opticsFirmwareConfig.map((e) => OpticsFirmwareConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpgradeOpticsFirmwareResponse>, I>>(base?: I): UpgradeOpticsFirmwareResponse {
    return UpgradeOpticsFirmwareResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpgradeOpticsFirmwareResponse>, I>>(
    object: I,
  ): UpgradeOpticsFirmwareResponse {
    const message = createBaseUpgradeOpticsFirmwareResponse();
    message.opticsFirmwareConfig = object.opticsFirmwareConfig?.map((e) => OpticsFirmwareConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOpticsFirmwareUpdateInfoRequest(): GetOpticsFirmwareUpdateInfoRequest {
  return { fabricId: "", opticsPids: [], opticsModels: [], switchGroups: [], nodePorts: [] };
}

export const GetOpticsFirmwareUpdateInfoRequest: MessageFns<GetOpticsFirmwareUpdateInfoRequest> = {
  encode(message: GetOpticsFirmwareUpdateInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.opticsPids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.opticsModels) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.switchGroups) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.nodePorts) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOpticsFirmwareUpdateInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOpticsFirmwareUpdateInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.opticsPids.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.opticsModels.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.switchGroups.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodePorts.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOpticsFirmwareUpdateInfoRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      opticsPids: globalThis.Array.isArray(object?.opticsPids)
        ? object.opticsPids.map((e: any) => globalThis.String(e))
        : [],
      opticsModels: globalThis.Array.isArray(object?.opticsModels)
        ? object.opticsModels.map((e: any) => globalThis.String(e))
        : [],
      switchGroups: globalThis.Array.isArray(object?.switchGroups)
        ? object.switchGroups.map((e: any) => globalThis.String(e))
        : [],
      nodePorts: globalThis.Array.isArray(object?.nodePorts)
        ? object.nodePorts.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetOpticsFirmwareUpdateInfoRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.opticsPids?.length) {
      obj.opticsPids = message.opticsPids;
    }
    if (message.opticsModels?.length) {
      obj.opticsModels = message.opticsModels;
    }
    if (message.switchGroups?.length) {
      obj.switchGroups = message.switchGroups;
    }
    if (message.nodePorts?.length) {
      obj.nodePorts = message.nodePorts;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOpticsFirmwareUpdateInfoRequest>, I>>(
    base?: I,
  ): GetOpticsFirmwareUpdateInfoRequest {
    return GetOpticsFirmwareUpdateInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOpticsFirmwareUpdateInfoRequest>, I>>(
    object: I,
  ): GetOpticsFirmwareUpdateInfoRequest {
    const message = createBaseGetOpticsFirmwareUpdateInfoRequest();
    message.fabricId = object.fabricId ?? "";
    message.opticsPids = object.opticsPids?.map((e) => e) || [];
    message.opticsModels = object.opticsModels?.map((e) => e) || [];
    message.switchGroups = object.switchGroups?.map((e) => e) || [];
    message.nodePorts = object.nodePorts?.map((e) => e) || [];
    return message;
  },
};

function createBaseOpticsFirmwareUpdateInfo(): OpticsFirmwareUpdateInfo {
  return {
    nodeName: "",
    portName: "",
    opticsPid: "",
    opticsModel: "",
    targetVersion: "",
    activated: false,
    activeFirmware: "",
    inactiveFirmware: "",
  };
}

export const OpticsFirmwareUpdateInfo: MessageFns<OpticsFirmwareUpdateInfo> = {
  encode(message: OpticsFirmwareUpdateInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    if (message.portName !== "") {
      writer.uint32(18).string(message.portName);
    }
    if (message.opticsPid !== "") {
      writer.uint32(26).string(message.opticsPid);
    }
    if (message.opticsModel !== "") {
      writer.uint32(34).string(message.opticsModel);
    }
    if (message.targetVersion !== "") {
      writer.uint32(42).string(message.targetVersion);
    }
    if (message.activated !== false) {
      writer.uint32(48).bool(message.activated);
    }
    if (message.activeFirmware !== "") {
      writer.uint32(58).string(message.activeFirmware);
    }
    if (message.inactiveFirmware !== "") {
      writer.uint32(66).string(message.inactiveFirmware);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpticsFirmwareUpdateInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpticsFirmwareUpdateInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.opticsPid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.opticsModel = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.activated = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.activeFirmware = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.inactiveFirmware = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpticsFirmwareUpdateInfo {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      opticsPid: isSet(object.opticsPid) ? globalThis.String(object.opticsPid) : "",
      opticsModel: isSet(object.opticsModel) ? globalThis.String(object.opticsModel) : "",
      targetVersion: isSet(object.targetVersion) ? globalThis.String(object.targetVersion) : "",
      activated: isSet(object.activated) ? globalThis.Boolean(object.activated) : false,
      activeFirmware: isSet(object.activeFirmware) ? globalThis.String(object.activeFirmware) : "",
      inactiveFirmware: isSet(object.inactiveFirmware) ? globalThis.String(object.inactiveFirmware) : "",
    };
  },

  toJSON(message: OpticsFirmwareUpdateInfo): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.opticsPid !== "") {
      obj.opticsPid = message.opticsPid;
    }
    if (message.opticsModel !== "") {
      obj.opticsModel = message.opticsModel;
    }
    if (message.targetVersion !== "") {
      obj.targetVersion = message.targetVersion;
    }
    if (message.activated !== false) {
      obj.activated = message.activated;
    }
    if (message.activeFirmware !== "") {
      obj.activeFirmware = message.activeFirmware;
    }
    if (message.inactiveFirmware !== "") {
      obj.inactiveFirmware = message.inactiveFirmware;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpticsFirmwareUpdateInfo>, I>>(base?: I): OpticsFirmwareUpdateInfo {
    return OpticsFirmwareUpdateInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpticsFirmwareUpdateInfo>, I>>(object: I): OpticsFirmwareUpdateInfo {
    const message = createBaseOpticsFirmwareUpdateInfo();
    message.nodeName = object.nodeName ?? "";
    message.portName = object.portName ?? "";
    message.opticsPid = object.opticsPid ?? "";
    message.opticsModel = object.opticsModel ?? "";
    message.targetVersion = object.targetVersion ?? "";
    message.activated = object.activated ?? false;
    message.activeFirmware = object.activeFirmware ?? "";
    message.inactiveFirmware = object.inactiveFirmware ?? "";
    return message;
  },
};

function createBaseGetOpticsFirmwareUpdateInfoResponse(): GetOpticsFirmwareUpdateInfoResponse {
  return { opticsFirmwareInfo: [] };
}

export const GetOpticsFirmwareUpdateInfoResponse: MessageFns<GetOpticsFirmwareUpdateInfoResponse> = {
  encode(message: GetOpticsFirmwareUpdateInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.opticsFirmwareInfo) {
      OpticsFirmwareUpdateInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOpticsFirmwareUpdateInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOpticsFirmwareUpdateInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.opticsFirmwareInfo.push(OpticsFirmwareUpdateInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOpticsFirmwareUpdateInfoResponse {
    return {
      opticsFirmwareInfo: globalThis.Array.isArray(object?.opticsFirmwareInfo)
        ? object.opticsFirmwareInfo.map((e: any) => OpticsFirmwareUpdateInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetOpticsFirmwareUpdateInfoResponse): unknown {
    const obj: any = {};
    if (message.opticsFirmwareInfo?.length) {
      obj.opticsFirmwareInfo = message.opticsFirmwareInfo.map((e) => OpticsFirmwareUpdateInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOpticsFirmwareUpdateInfoResponse>, I>>(
    base?: I,
  ): GetOpticsFirmwareUpdateInfoResponse {
    return GetOpticsFirmwareUpdateInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOpticsFirmwareUpdateInfoResponse>, I>>(
    object: I,
  ): GetOpticsFirmwareUpdateInfoResponse {
    const message = createBaseGetOpticsFirmwareUpdateInfoResponse();
    message.opticsFirmwareInfo = object.opticsFirmwareInfo?.map((e) => OpticsFirmwareUpdateInfo.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
